module.exports = __webpack_public_path__ + "static/media/96gal08.347bf966.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/96gal/96gal08.jpg
// module id = 285
// module chunks = 0